// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/datasets.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_chalk_auth_v1_permissions } from "../../auth/v1/permissions_pb";
import type { DenseTimeSeriesChart } from "../../chart/v1/densetimeserieschart_pb";
import { file_chalk_chart_v1_densetimeserieschart } from "../../chart/v1/densetimeserieschart_pb";
import type { ColumnProfile } from "../../common/v1/column_profile_pb";
import { file_chalk_common_v1_column_profile } from "../../common/v1/column_profile_pb";
import type { ExecuteSqlQueryResponse } from "../../protosql/v1/sql_service_pb";
import { file_chalk_protosql_v1_sql_service } from "../../protosql/v1/sql_service_pb";
import type { GetFeatureMaterializedAggregationsRequestSchema, GetFeatureMaterializedAggregationsResponseSchema, GetMaterializedAggregateTileFacetsRequestSchema, GetMaterializedAggregateTileFacetsResponseSchema, GetMaterializedAggregateTileFacetValuesRequestSchema, GetMaterializedAggregateTileFacetValuesResponseSchema, ListMaterializedAggregateTileTimelinesRequestSchema, ListMaterializedAggregateTileTimelinesResponseSchema, ListTileFeatureCoverageRequestSchema, ListTileFeatureCoverageResponseSchema, MaterializedAggregateTileTimelineInterval } from "./materialized_aggregate_tiles_pb";
import { file_chalk_server_v1_materialized_aggregate_tiles } from "./materialized_aggregate_tiles_pb";
import type { AzureBlockUpload, DirectUpload, MultipartUpload, ResumableUpload } from "../../volume/v1/volume_pb";
import { file_chalk_volume_v1_volume } from "../../volume/v1/volume_pb";
import type { FieldMask, Timestamp, Value } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/server/v1/datasets.proto.
 */
export const file_chalk_server_v1_datasets: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_auth_v1_permissions, file_chalk_chart_v1_densetimeserieschart, file_chalk_common_v1_column_profile, file_chalk_protosql_v1_sql_service, file_chalk_server_v1_materialized_aggregate_tiles, file_chalk_volume_v1_volume, file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.server.v1.DatasetRevisionMeta
 */
export type DatasetRevisionMeta = Message<"chalk.server.v1.DatasetRevisionMeta"> & {
  /**
   * @generated from field: int64 numeric_id = 1;
   */
  numericId: bigint;

  /**
   * @generated from field: string offline_query_id = 2;
   */
  offlineQueryId: string;

  /**
   * @generated from field: string dataset_id = 3;
   */
  datasetId: string;

  /**
   * @generated from field: optional string givens_uri = 4;
   */
  givensUri?: string;

  /**
   * @generated from field: optional chalk.server.v1.OfflineQueryGivensVersion givens_version = 5;
   */
  givensVersion?: OfflineQueryGivensVersion;

  /**
   * @generated from field: optional string output_uri = 6;
   */
  outputUri?: string;

  /**
   * @generated from field: optional chalk.server.v1.DatasetVersion output_version = 7;
   */
  outputVersion?: DatasetVersion;

  /**
   * @generated from field: optional string branch_name = 8;
   */
  branchName?: string;

  /**
   * @generated from field: optional int64 num_rows = 9 [deprecated = true];
   * @deprecated
   */
  numRows?: bigint;

  /**
   * @generated from field: optional int64 physical_size_bytes = 10 [deprecated = true];
   * @deprecated
   */
  physicalSizeBytes?: bigint;

  /**
   * @generated from field: repeated string output_columns = 11;
   */
  outputColumns: string[];

  /**
   * @generated from field: repeated string output_fqns = 12;
   */
  outputFqns: string[];

  /**
   * @generated from field: optional string agent_id = 13;
   */
  agentId?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp completed_at = 14;
   */
  completedAt?: Timestamp;

  /**
   * @generated from field: optional int64 num_shards = 15;
   */
  numShards?: bigint;

  /**
   * @generated from field: optional int64 num_computers = 16;
   */
  numComputers?: bigint;

  /**
   * @generated from field: optional google.protobuf.Value metadata = 17;
   */
  metadata?: Value;

  /**
   * This field is populated by converting the status from the associated offline query.
   *
   * @generated from field: optional chalk.server.v1.DatasetRevisionStatus status = 18;
   */
  status?: DatasetRevisionStatus;

  /**
   * @generated from field: optional int64 num_rows_calculated = 19;
   */
  numRowsCalculated?: bigint;

  /**
   * @generated from field: optional int64 physical_size_bytes_calculated = 20;
   */
  physicalSizeBytesCalculated?: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 21;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp archived_at = 22;
   */
  archivedAt?: Timestamp;

  /**
   * IPC-serialized arrow schema describing the columns of the parquet
   * files at output_uri. Set on revisions produced via FinalizeDatasetUpload
   * (where the client extracts and ships the schema); legacy revisions
   * produced by offline-query execution leave this unset.
   *
   * @generated from field: optional bytes output_arrow_schema_serialized = 23;
   */
  outputArrowSchemaSerialized?: Uint8Array;

  /**
   * Features this revision recorded a value distribution for, which a feature
   * drift monitor can use as its baseline. Populated only by ListDatasetRevisions
   * with filters.feature_drift_eligible set.
   *
   * @generated from field: repeated string feature_distribution_fqns = 24;
   */
  featureDistributionFqns: string[];
};

/**
 * Describes the message chalk.server.v1.DatasetRevisionMeta.
 * Use `create(DatasetRevisionMetaSchema)` to create a new message.
 */
export const DatasetRevisionMetaSchema: GenMessage<DatasetRevisionMeta> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 0);

/**
 * @generated from message chalk.server.v1.DatasetMeta
 */
export type DatasetMeta = Message<"chalk.server.v1.DatasetMeta"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string environment_id = 2;
   */
  environmentId: string;

  /**
   * @generated from field: optional string dataset_name = 3;
   */
  datasetName?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional chalk.server.v1.DatasetRevisionMeta most_recent_revision = 7;
   */
  mostRecentRevision?: DatasetRevisionMeta;

  /**
   * Number of non-archived revisions currently associated with this dataset.
   *
   * @generated from field: optional int64 num_revisions = 8;
   */
  numRevisions?: bigint;
};

/**
 * Describes the message chalk.server.v1.DatasetMeta.
 * Use `create(DatasetMetaSchema)` to create a new message.
 */
export const DatasetMetaSchema: GenMessage<DatasetMeta> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 1);

/**
 * @generated from message chalk.server.v1.ListDatasetsRequest
 */
export type ListDatasetsRequest = Message<"chalk.server.v1.ListDatasetsRequest"> & {
  /**
   * @generated from field: optional string cursor = 1;
   */
  cursor?: string;

  /**
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;

  /**
   * Deprecated in favor of `filters.search`.
   *
   * @generated from field: optional string search = 3 [deprecated = true];
   * @deprecated
   */
  search?: string;

  /**
   * Deprecated in favor of `filters.kind` (kept for backwards compatibility): when true,
   * anonymous datasets are included alongside named ones. Ignored when `kind` is
   * set. Callers that send `kind` should leave this unset.
   *
   * @generated from field: optional bool include_anonymous = 4 [deprecated = true];
   * @deprecated
   */
  includeAnonymous?: boolean;

  /**
   * @generated from field: optional chalk.server.v1.DatasetSortColumn sort_column = 5;
   */
  sortColumn?: DatasetSortColumn;

  /**
   * @generated from field: optional chalk.server.v1.SortOrder sort_order = 6;
   */
  sortOrder?: SortOrder;

  /**
   * Deprecated in favor of `filters.status`.
   * Filter to datasets whose most-recent revision has one of these statuses.
   * Empty = no status filter.
   *
   * @generated from field: repeated chalk.server.v1.DatasetRevisionStatus status = 7 [deprecated = true];
   * @deprecated
   */
  status: DatasetRevisionStatus[];

  /**
   * Deprecated in favor of `filters.kind`.
   * Which kinds of dataset to include. Supersedes `include_anonymous` when
   * non-empty; empty falls back to `include_anonymous` (named always included).
   *
   * @generated from field: repeated chalk.server.v1.DatasetKind kind = 8 [deprecated = true];
   * @deprecated
   */
  kind: DatasetKind[];

  /**
   * Deprecated in favor of `filters.ids`.
   * Restrict the result to these dataset ids. Empty lists the environment catalog.
   *
   * @generated from field: repeated string ids = 9 [deprecated = true];
   * @deprecated
   */
  ids: string[];

  /**
   * Fields to return on each DatasetMeta. Empty returns the full resource.
   *
   * @generated from field: optional google.protobuf.FieldMask read_mask = 10;
   */
  readMask?: FieldMask;

  /**
   * @generated from field: optional chalk.server.v1.ListDatasetsFilters filters = 11;
   */
  filters?: ListDatasetsFilters;
};

/**
 * Describes the message chalk.server.v1.ListDatasetsRequest.
 * Use `create(ListDatasetsRequestSchema)` to create a new message.
 */
export const ListDatasetsRequestSchema: GenMessage<ListDatasetsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 2);

/**
 * @generated from message chalk.server.v1.ListDatasetsFilters
 */
export type ListDatasetsFilters = Message<"chalk.server.v1.ListDatasetsFilters"> & {
  /**
   * Filter by the agent that created the latest revision for each dataset.
   *
   * @generated from field: repeated string agent_ids = 1;
   */
  agentIds: string[];

  /**
   * Filter dataset names by substring.
   *
   * @generated from field: optional string search = 2;
   */
  search?: string;

  /**
   * Filter to datasets whose most-recent revision has one of these statuses.
   * Empty = no status filter.
   *
   * @generated from field: repeated chalk.server.v1.DatasetRevisionStatus status = 3;
   */
  status: DatasetRevisionStatus[];

  /**
   * Which kinds of dataset to include. Empty includes named and anonymous datasets.
   *
   * @generated from field: repeated chalk.server.v1.DatasetKind kind = 4;
   */
  kind: DatasetKind[];

  /**
   * Restrict the result to these dataset ids. Empty lists the environment catalog.
   *
   * @generated from field: repeated string ids = 5;
   */
  ids: string[];

  /**
   * Only datasets with a revision a feature drift monitor can compare against:
   * completed, unarchived, and with a recorded value distribution for at least
   * one feature. Only numeric features record a distribution.
   *
   * @generated from field: optional bool feature_drift_eligible = 6;
   */
  featureDriftEligible?: boolean;
};

/**
 * Describes the message chalk.server.v1.ListDatasetsFilters.
 * Use `create(ListDatasetsFiltersSchema)` to create a new message.
 */
export const ListDatasetsFiltersSchema: GenMessage<ListDatasetsFilters> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 3);

/**
 * @generated from message chalk.server.v1.ListDatasetsResponse
 */
export type ListDatasetsResponse = Message<"chalk.server.v1.ListDatasetsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.DatasetMeta datasets = 1;
   */
  datasets: DatasetMeta[];

  /**
   * @generated from field: optional string cursor = 2;
   */
  cursor?: string;
};

/**
 * Describes the message chalk.server.v1.ListDatasetsResponse.
 * Use `create(ListDatasetsResponseSchema)` to create a new message.
 */
export const ListDatasetsResponseSchema: GenMessage<ListDatasetsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 4);

/**
 * @generated from message chalk.server.v1.GetDatasetRequest
 */
export type GetDatasetRequest = Message<"chalk.server.v1.GetDatasetRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chalk.server.v1.GetDatasetRequest.
 * Use `create(GetDatasetRequestSchema)` to create a new message.
 */
export const GetDatasetRequestSchema: GenMessage<GetDatasetRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 5);

/**
 * @generated from message chalk.server.v1.GetDatasetResponse
 */
export type GetDatasetResponse = Message<"chalk.server.v1.GetDatasetResponse"> & {
  /**
   * @generated from field: chalk.server.v1.DatasetMeta dataset = 1;
   */
  dataset?: DatasetMeta;
};

/**
 * Describes the message chalk.server.v1.GetDatasetResponse.
 * Use `create(GetDatasetResponseSchema)` to create a new message.
 */
export const GetDatasetResponseSchema: GenMessage<GetDatasetResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 6);

/**
 * @generated from message chalk.server.v1.ListDatasetRevisionsRequest
 */
export type ListDatasetRevisionsRequest = Message<"chalk.server.v1.ListDatasetRevisionsRequest"> & {
  /**
   * @generated from field: string dataset_id = 1;
   */
  datasetId: string;

  /**
   * @generated from field: optional string cursor = 2;
   */
  cursor?: string;

  /**
   * @generated from field: optional int32 limit = 3;
   */
  limit?: number;

  /**
   * Deprecated in favor of `filters.include_archived`.
   *
   * @generated from field: optional bool include_archived = 4 [deprecated = true];
   * @deprecated
   */
  includeArchived?: boolean;

  /**
   * Deprecated in favor of `filters.start_time`.
   * Start time filter - only include revisions created after this time (inclusive)
   *
   * @generated from field: optional google.protobuf.Timestamp start_time = 5 [deprecated = true];
   * @deprecated
   */
  startTime?: Timestamp;

  /**
   * Deprecated in favor of `filters.end_time`.
   * End time filter - only include revisions created before this time (exclusive)
   *
   * @generated from field: optional google.protobuf.Timestamp end_time = 6 [deprecated = true];
   * @deprecated
   */
  endTime?: Timestamp;

  /**
   * @generated from field: optional chalk.server.v1.ListDatasetRevisionsFilters filters = 7;
   */
  filters?: ListDatasetRevisionsFilters;
};

/**
 * Describes the message chalk.server.v1.ListDatasetRevisionsRequest.
 * Use `create(ListDatasetRevisionsRequestSchema)` to create a new message.
 */
export const ListDatasetRevisionsRequestSchema: GenMessage<ListDatasetRevisionsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 7);

/**
 * @generated from message chalk.server.v1.ListDatasetRevisionsFilters
 */
export type ListDatasetRevisionsFilters = Message<"chalk.server.v1.ListDatasetRevisionsFilters"> & {
  /**
   * Filter by the agent that created the revision.
   *
   * @generated from field: repeated string agent_ids = 1;
   */
  agentIds: string[];

  /**
   * Whether archived revisions should be included.
   *
   * @generated from field: optional bool include_archived = 2;
   */
  includeArchived?: boolean;

  /**
   * Only include revisions created after this time (inclusive).
   *
   * @generated from field: optional google.protobuf.Timestamp start_time = 3;
   */
  startTime?: Timestamp;

  /**
   * Only include revisions created before this time (exclusive).
   *
   * @generated from field: optional google.protobuf.Timestamp end_time = 4;
   */
  endTime?: Timestamp;

  /**
   * Only revisions a feature drift monitor can compare against: completed,
   * unarchived, and with a recorded value distribution for at least one
   * feature. Also populates each revision's feature_distribution_fqns.
   *
   * @generated from field: optional bool feature_drift_eligible = 5;
   */
  featureDriftEligible?: boolean;
};

/**
 * Describes the message chalk.server.v1.ListDatasetRevisionsFilters.
 * Use `create(ListDatasetRevisionsFiltersSchema)` to create a new message.
 */
export const ListDatasetRevisionsFiltersSchema: GenMessage<ListDatasetRevisionsFilters> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 8);

/**
 * @generated from message chalk.server.v1.ListDatasetRevisionsResponse
 */
export type ListDatasetRevisionsResponse = Message<"chalk.server.v1.ListDatasetRevisionsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.DatasetRevisionMeta revisions = 1;
   */
  revisions: DatasetRevisionMeta[];

  /**
   * @generated from field: optional string cursor = 2;
   */
  cursor?: string;
};

/**
 * Describes the message chalk.server.v1.ListDatasetRevisionsResponse.
 * Use `create(ListDatasetRevisionsResponseSchema)` to create a new message.
 */
export const ListDatasetRevisionsResponseSchema: GenMessage<ListDatasetRevisionsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 9);

/**
 * @generated from message chalk.server.v1.GetDatasetRevisionRequest
 */
export type GetDatasetRevisionRequest = Message<"chalk.server.v1.GetDatasetRevisionRequest"> & {
  /**
   * @generated from field: string revision_id = 1;
   */
  revisionId: string;

  /**
   * @generated from field: optional bool include_archived = 2;
   */
  includeArchived?: boolean;
};

/**
 * Describes the message chalk.server.v1.GetDatasetRevisionRequest.
 * Use `create(GetDatasetRevisionRequestSchema)` to create a new message.
 */
export const GetDatasetRevisionRequestSchema: GenMessage<GetDatasetRevisionRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 10);

/**
 * @generated from message chalk.server.v1.GetDatasetRevisionResponse
 */
export type GetDatasetRevisionResponse = Message<"chalk.server.v1.GetDatasetRevisionResponse"> & {
  /**
   * @generated from field: chalk.server.v1.DatasetRevisionMeta revision = 1;
   */
  revision?: DatasetRevisionMeta;
};

/**
 * Describes the message chalk.server.v1.GetDatasetRevisionResponse.
 * Use `create(GetDatasetRevisionResponseSchema)` to create a new message.
 */
export const GetDatasetRevisionResponseSchema: GenMessage<GetDatasetRevisionResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 11);

/**
 * @generated from message chalk.server.v1.GetDatasetRevisionDownloadLinksRequest
 */
export type GetDatasetRevisionDownloadLinksRequest = Message<"chalk.server.v1.GetDatasetRevisionDownloadLinksRequest"> & {
  /**
   * @generated from field: string revision_id = 1;
   */
  revisionId: string;
};

/**
 * Describes the message chalk.server.v1.GetDatasetRevisionDownloadLinksRequest.
 * Use `create(GetDatasetRevisionDownloadLinksRequestSchema)` to create a new message.
 */
export const GetDatasetRevisionDownloadLinksRequestSchema: GenMessage<GetDatasetRevisionDownloadLinksRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 12);

/**
 * Per-shard performance-summary descriptor. One entry per shard the revision
 * ran. `url` is set only when status is AVAILABLE.
 *
 * @generated from message chalk.server.v1.ShardPerformanceSummaryLink
 */
export type ShardPerformanceSummaryLink = Message<"chalk.server.v1.ShardPerformanceSummaryLink"> & {
  /**
   * @generated from field: int32 shard_id = 1;
   */
  shardId: number;

  /**
   * @generated from field: optional string url = 2;
   */
  url?: string;

  /**
   * @generated from field: chalk.server.v1.ShardPerformanceSummaryStatus status = 3;
   */
  status: ShardPerformanceSummaryStatus;
};

/**
 * Describes the message chalk.server.v1.ShardPerformanceSummaryLink.
 * Use `create(ShardPerformanceSummaryLinkSchema)` to create a new message.
 */
export const ShardPerformanceSummaryLinkSchema: GenMessage<ShardPerformanceSummaryLink> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 13);

/**
 * Per-shard offline-query request-body descriptor. `url` is set only when the
 * body exists in bucket storage.
 *
 * @generated from message chalk.server.v1.ShardRequestBodyLink
 */
export type ShardRequestBodyLink = Message<"chalk.server.v1.ShardRequestBodyLink"> & {
  /**
   * @generated from field: int32 shard_id = 1;
   */
  shardId: number;

  /**
   * @generated from field: optional string url = 2;
   */
  url?: string;

  /**
   * @generated from field: bool exists = 3;
   */
  exists: boolean;
};

/**
 * Describes the message chalk.server.v1.ShardRequestBodyLink.
 * Use `create(ShardRequestBodyLinkSchema)` to create a new message.
 */
export const ShardRequestBodyLinkSchema: GenMessage<ShardRequestBodyLink> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 14);

/**
 * @generated from message chalk.server.v1.GetDatasetRevisionDownloadLinksResponse
 */
export type GetDatasetRevisionDownloadLinksResponse = Message<"chalk.server.v1.GetDatasetRevisionDownloadLinksResponse"> & {
  /**
   * @generated from field: repeated string output_urls = 1;
   */
  outputUrls: string[];

  /**
   * @generated from field: repeated string givens_urls = 2;
   */
  givensUrls: string[];

  /**
   * Superseded by performance_summary_links (field 8), which carries one entry
   * per shard with an availability status. Kept for rollout compatibility.
   *
   * @generated from field: repeated string performance_summary_urls = 3 [deprecated = true];
   * @deprecated
   */
  performanceSummaryUrls: string[];

  /**
   * @generated from field: optional string request_body_url = 4;
   */
  requestBodyUrl?: string;

  /**
   * @generated from field: repeated string trace_urls = 5;
   */
  traceUrls: string[];

  /**
   * @generated from field: optional string error = 6;
   */
  error?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp expiration = 7;
   */
  expiration?: Timestamp;

  /**
   * One entry per shard the revision ran, each with an availability status.
   *
   * @generated from field: repeated chalk.server.v1.ShardPerformanceSummaryLink performance_summary_links = 8 [deprecated = true];
   * @deprecated
   */
  performanceSummaryLinks: ShardPerformanceSummaryLink[];

  /**
   * One entry per shard the revision ran. Missing bodies are represented with
   * exists=false so callers can distinguish old revisions from available bodies.
   *
   * @generated from field: repeated chalk.server.v1.ShardRequestBodyLink shard_request_body_links = 9;
   */
  shardRequestBodyLinks: ShardRequestBodyLink[];
};

/**
 * Describes the message chalk.server.v1.GetDatasetRevisionDownloadLinksResponse.
 * Use `create(GetDatasetRevisionDownloadLinksResponseSchema)` to create a new message.
 */
export const GetDatasetRevisionDownloadLinksResponseSchema: GenMessage<GetDatasetRevisionDownloadLinksResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 15);

/**
 * @generated from message chalk.server.v1.GetDatasetRevisionPerformanceLinksRequest
 */
export type GetDatasetRevisionPerformanceLinksRequest = Message<"chalk.server.v1.GetDatasetRevisionPerformanceLinksRequest"> & {
  /**
   * @generated from field: string revision_id = 1;
   */
  revisionId: string;
};

/**
 * Describes the message chalk.server.v1.GetDatasetRevisionPerformanceLinksRequest.
 * Use `create(GetDatasetRevisionPerformanceLinksRequestSchema)` to create a new message.
 */
export const GetDatasetRevisionPerformanceLinksRequestSchema: GenMessage<GetDatasetRevisionPerformanceLinksRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 16);

/**
 * @generated from message chalk.server.v1.GetDatasetRevisionPerformanceLinksResponse
 */
export type GetDatasetRevisionPerformanceLinksResponse = Message<"chalk.server.v1.GetDatasetRevisionPerformanceLinksResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.ShardPerformanceSummaryLink performance_summary_links = 1;
   */
  performanceSummaryLinks: ShardPerformanceSummaryLink[];

  /**
   * @generated from field: optional string error = 2;
   */
  error?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp expiration = 3;
   */
  expiration?: Timestamp;
};

/**
 * Describes the message chalk.server.v1.GetDatasetRevisionPerformanceLinksResponse.
 * Use `create(GetDatasetRevisionPerformanceLinksResponseSchema)` to create a new message.
 */
export const GetDatasetRevisionPerformanceLinksResponseSchema: GenMessage<GetDatasetRevisionPerformanceLinksResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 17);

/**
 * @generated from message chalk.server.v1.StreamDatasetRevisionDownloadLinksRequest
 */
export type StreamDatasetRevisionDownloadLinksRequest = Message<"chalk.server.v1.StreamDatasetRevisionDownloadLinksRequest"> & {
  /**
   * @generated from field: string revision_id = 1;
   */
  revisionId: string;
};

/**
 * Describes the message chalk.server.v1.StreamDatasetRevisionDownloadLinksRequest.
 * Use `create(StreamDatasetRevisionDownloadLinksRequestSchema)` to create a new message.
 */
export const StreamDatasetRevisionDownloadLinksRequestSchema: GenMessage<StreamDatasetRevisionDownloadLinksRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 18);

/**
 * One chunk of dataset revision download links. Repeated url fields are partial
 * across the stream — clients should concatenate them as messages arrive. Each
 * message that contains any signed URLs also sets `expiration` to the shared
 * expiration timestamp; messages with no URLs may omit it.
 *
 * @generated from message chalk.server.v1.StreamDatasetRevisionDownloadLinksResponse
 */
export type StreamDatasetRevisionDownloadLinksResponse = Message<"chalk.server.v1.StreamDatasetRevisionDownloadLinksResponse"> & {
  /**
   * @generated from field: repeated string output_urls = 1;
   */
  outputUrls: string[];

  /**
   * @generated from field: repeated string givens_urls = 2;
   */
  givensUrls: string[];

  /**
   * @generated from field: repeated string performance_summary_urls = 3;
   */
  performanceSummaryUrls: string[];

  /**
   * @generated from field: optional string request_body_url = 4;
   */
  requestBodyUrl?: string;

  /**
   * @generated from field: repeated string trace_urls = 5;
   */
  traceUrls: string[];

  /**
   * @generated from field: optional string error = 6;
   */
  error?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp expiration = 7;
   */
  expiration?: Timestamp;

  /**
   * Present for schema parity with the unary response. Not yet populated by the
   * streaming handler (would require chunking); the unary RPC is the consumer.
   *
   * @generated from field: repeated chalk.server.v1.ShardPerformanceSummaryLink performance_summary_links = 8;
   */
  performanceSummaryLinks: ShardPerformanceSummaryLink[];
};

/**
 * Describes the message chalk.server.v1.StreamDatasetRevisionDownloadLinksResponse.
 * Use `create(StreamDatasetRevisionDownloadLinksResponseSchema)` to create a new message.
 */
export const StreamDatasetRevisionDownloadLinksResponseSchema: GenMessage<StreamDatasetRevisionDownloadLinksResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 19);

/**
 * Request a signed upload URI for a single client-side file destined for a
 * dataset upload. Call once per file. The first call should leave
 * upload_session_id unset; the server mints one and returns it. Pass that same
 * upload_session_id back on subsequent calls and on FinalizeDatasetUpload to
 * associate all uploaded objects with the same revision.
 *
 * @generated from message chalk.server.v1.GetDatasetUploadUrisRequest
 */
export type GetDatasetUploadUrisRequest = Message<"chalk.server.v1.GetDatasetUploadUrisRequest"> & {
  /**
   * Total size of the file in bytes.
   *
   * @generated from field: int64 content_size = 1;
   */
  contentSize: bigint;

  /**
   * Optional content hash for integrity verification (e.g. SHA-256 hex).
   *
   * @generated from field: optional string hash = 2;
   */
  hash?: string;

  /**
   * Desired multipart part size in bytes. Server may adjust.
   *
   * @generated from field: optional int64 part_size = 3;
   */
  partSize?: bigint;

  /**
   * If set, attaches this upload to the given session created by a prior call.
   * If unset, the server mints and returns a new session id.
   *
   * @generated from field: optional string upload_session_id = 4;
   */
  uploadSessionId?: string;
};

/**
 * Describes the message chalk.server.v1.GetDatasetUploadUrisRequest.
 * Use `create(GetDatasetUploadUrisRequestSchema)` to create a new message.
 */
export const GetDatasetUploadUrisRequestSchema: GenMessage<GetDatasetUploadUrisRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 20);

/**
 * @generated from message chalk.server.v1.GetDatasetUploadUrisResponse
 */
export type GetDatasetUploadUrisResponse = Message<"chalk.server.v1.GetDatasetUploadUrisResponse"> & {
  /**
   * Session id grouping uploads together. Pass this on subsequent
   * GetDatasetUploadUris calls and on FinalizeDatasetUpload. The session id
   * is also baked into the deterministic storage path the server signs URIs
   * for, so finalize needs no per-session state on the server.
   *
   * @generated from field: string upload_session_id = 1;
   */
  uploadSessionId: string;

  /**
   * Bucket-relative path the signed URI uploads to. Informational for the
   * client — finalize derives the same path from upload_session_id, so the
   * client does not need to send it back.
   *
   * @generated from field: string storage_object_id = 2;
   */
  storageObjectId: string;

  /**
   * Object-store-specific upload mechanism. The chosen variant depends on the
   * environment's offline-store backend (S3, GCS, or Azure).
   *
   * @generated from oneof chalk.server.v1.GetDatasetUploadUrisResponse.upload
   */
  upload: {
    /**
     * @generated from field: chalk.volume.v1.MultipartUpload multipart = 3;
     */
    value: MultipartUpload;
    case: "multipart";
  } | {
    /**
     * @generated from field: chalk.volume.v1.ResumableUpload resumable = 4;
     */
    value: ResumableUpload;
    case: "resumable";
  } | {
    /**
     * @generated from field: chalk.volume.v1.AzureBlockUpload azure_block = 5;
     */
    value: AzureBlockUpload;
    case: "azureBlock";
  } | {
    /**
     * @generated from field: chalk.volume.v1.DirectUpload direct = 6;
     */
    value: DirectUpload;
    case: "direct";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.server.v1.GetDatasetUploadUrisResponse.
 * Use `create(GetDatasetUploadUrisResponseSchema)` to create a new message.
 */
export const GetDatasetUploadUrisResponseSchema: GenMessage<GetDatasetUploadUrisResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 21);

/**
 * Finalize a dataset upload session. The server records a new dataset revision
 * pointing at all storage objects uploaded under upload_session_id, under a
 * dataset named dataset_name. If a dataset with that name already exists, a
 * new revision is appended; otherwise a new dataset is created. After this
 * call returns successfully, the dataset is queryable via the usual dataset
 * APIs.
 *
 * Finalization is one-shot: a given upload_session_id may be finalized at most
 * once. Re-calling FinalizeDatasetUpload with the same upload_session_id
 * returns an ALREADY_EXISTS error rather than creating an additional revision.
 *
 * @generated from message chalk.server.v1.FinalizeDatasetUploadRequest
 */
export type FinalizeDatasetUploadRequest = Message<"chalk.server.v1.FinalizeDatasetUploadRequest"> & {
  /**
   * @generated from field: string upload_session_id = 1;
   */
  uploadSessionId: string;

  /**
   * @generated from field: string dataset_name = 2;
   */
  datasetName: string;

  /**
   * IPC-serialized arrow schema describing the columns of the uploaded
   * parquet files. The client extracts this from one of the uploaded files
   * before calling FinalizeDatasetUpload and sends it here so the server can
   * record it on the new dataset revision without re-reading the parquet.
   *
   * @generated from field: bytes arrow_schema_serialized = 3;
   */
  arrowSchemaSerialized: Uint8Array;
};

/**
 * Describes the message chalk.server.v1.FinalizeDatasetUploadRequest.
 * Use `create(FinalizeDatasetUploadRequestSchema)` to create a new message.
 */
export const FinalizeDatasetUploadRequestSchema: GenMessage<FinalizeDatasetUploadRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 22);

/**
 * @generated from message chalk.server.v1.FinalizeDatasetUploadResponse
 */
export type FinalizeDatasetUploadResponse = Message<"chalk.server.v1.FinalizeDatasetUploadResponse"> & {
  /**
   * @generated from field: chalk.server.v1.DatasetMeta dataset = 1;
   */
  dataset?: DatasetMeta;
};

/**
 * Describes the message chalk.server.v1.FinalizeDatasetUploadResponse.
 * Use `create(FinalizeDatasetUploadResponseSchema)` to create a new message.
 */
export const FinalizeDatasetUploadResponseSchema: GenMessage<FinalizeDatasetUploadResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 23);

/**
 * @generated from message chalk.server.v1.RenameDatasetRequest
 */
export type RenameDatasetRequest = Message<"chalk.server.v1.RenameDatasetRequest"> & {
  /**
   * @generated from field: string dataset_id = 1;
   */
  datasetId: string;

  /**
   * @generated from field: string new_name = 2;
   */
  newName: string;
};

/**
 * Describes the message chalk.server.v1.RenameDatasetRequest.
 * Use `create(RenameDatasetRequestSchema)` to create a new message.
 */
export const RenameDatasetRequestSchema: GenMessage<RenameDatasetRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 24);

/**
 * @generated from message chalk.server.v1.RenameDatasetResponse
 */
export type RenameDatasetResponse = Message<"chalk.server.v1.RenameDatasetResponse"> & {
  /**
   * @generated from field: chalk.server.v1.DatasetMeta dataset = 1;
   */
  dataset?: DatasetMeta;
};

/**
 * Describes the message chalk.server.v1.RenameDatasetResponse.
 * Use `create(RenameDatasetResponseSchema)` to create a new message.
 */
export const RenameDatasetResponseSchema: GenMessage<RenameDatasetResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 25);

/**
 * @generated from message chalk.server.v1.ArchiveDatasetRevisionRequest
 */
export type ArchiveDatasetRevisionRequest = Message<"chalk.server.v1.ArchiveDatasetRevisionRequest"> & {
  /**
   * @generated from field: string revision_id = 1;
   */
  revisionId: string;
};

/**
 * Describes the message chalk.server.v1.ArchiveDatasetRevisionRequest.
 * Use `create(ArchiveDatasetRevisionRequestSchema)` to create a new message.
 */
export const ArchiveDatasetRevisionRequestSchema: GenMessage<ArchiveDatasetRevisionRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 26);

/**
 * @generated from message chalk.server.v1.ArchiveDatasetRevisionResponse
 */
export type ArchiveDatasetRevisionResponse = Message<"chalk.server.v1.ArchiveDatasetRevisionResponse"> & {
  /**
   * @generated from field: chalk.server.v1.DatasetRevisionMeta revision = 1;
   */
  revision?: DatasetRevisionMeta;
};

/**
 * Describes the message chalk.server.v1.ArchiveDatasetRevisionResponse.
 * Use `create(ArchiveDatasetRevisionResponseSchema)` to create a new message.
 */
export const ArchiveDatasetRevisionResponseSchema: GenMessage<ArchiveDatasetRevisionResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 27);

/**
 * @generated from message chalk.server.v1.ArchiveDatasetRevisionsRequest
 */
export type ArchiveDatasetRevisionsRequest = Message<"chalk.server.v1.ArchiveDatasetRevisionsRequest"> & {
  /**
   * @generated from field: repeated string revision_ids = 1;
   */
  revisionIds: string[];
};

/**
 * Describes the message chalk.server.v1.ArchiveDatasetRevisionsRequest.
 * Use `create(ArchiveDatasetRevisionsRequestSchema)` to create a new message.
 */
export const ArchiveDatasetRevisionsRequestSchema: GenMessage<ArchiveDatasetRevisionsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 28);

/**
 * @generated from message chalk.server.v1.ArchiveDatasetRevisionsResponse
 */
export type ArchiveDatasetRevisionsResponse = Message<"chalk.server.v1.ArchiveDatasetRevisionsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.DatasetRevisionMeta archived_revisions = 1;
   */
  archivedRevisions: DatasetRevisionMeta[];
};

/**
 * Describes the message chalk.server.v1.ArchiveDatasetRevisionsResponse.
 * Use `create(ArchiveDatasetRevisionsResponseSchema)` to create a new message.
 */
export const ArchiveDatasetRevisionsResponseSchema: GenMessage<ArchiveDatasetRevisionsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 29);

/**
 * @generated from message chalk.server.v1.DeleteDatasetRequest
 */
export type DeleteDatasetRequest = Message<"chalk.server.v1.DeleteDatasetRequest"> & {
  /**
   * @generated from field: string dataset_id = 1;
   */
  datasetId: string;
};

/**
 * Describes the message chalk.server.v1.DeleteDatasetRequest.
 * Use `create(DeleteDatasetRequestSchema)` to create a new message.
 */
export const DeleteDatasetRequestSchema: GenMessage<DeleteDatasetRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 30);

/**
 * @generated from message chalk.server.v1.DeleteDatasetResponse
 */
export type DeleteDatasetResponse = Message<"chalk.server.v1.DeleteDatasetResponse"> & {
  /**
   * @generated from field: string dataset_id = 1;
   */
  datasetId: string;
};

/**
 * Describes the message chalk.server.v1.DeleteDatasetResponse.
 * Use `create(DeleteDatasetResponseSchema)` to create a new message.
 */
export const DeleteDatasetResponseSchema: GenMessage<DeleteDatasetResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 31);

/**
 * @generated from message chalk.server.v1.MaterializedAggregateTileMeta
 */
export type MaterializedAggregateTileMeta = Message<"chalk.server.v1.MaterializedAggregateTileMeta"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string environment_id = 18;
   */
  environmentId: string;

  /**
   * @generated from field: string deployment_id = 2;
   */
  deploymentId: string;

  /**
   * @generated from field: string operation_id = 3;
   */
  operationId: string;

  /**
   * @generated from field: string aggregate_backfill_id = 4;
   */
  aggregateBackfillId: string;

  /**
   * @generated from field: string materialization_key_hash = 5;
   */
  materializationKeyHash: string;

  /**
   * @generated from field: string aggregation = 6;
   */
  aggregation: string;

  /**
   * @generated from field: string aggregate_on = 7;
   */
  aggregateOn: string;

  /**
   * @generated from field: repeated string groups = 8;
   */
  groups: string[];

  /**
   * @generated from field: string bucket_on = 9;
   */
  bucketOn: string;

  /**
   * @generated from field: int64 bucket_duration_ms = 10;
   */
  bucketDurationMs: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp coverage_lower_bound = 11;
   */
  coverageLowerBound?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp coverage_upper_bound = 12;
   */
  coverageUpperBound?: Timestamp;

  /**
   * @generated from field: string source_kind = 13;
   */
  sourceKind: string;

  /**
   * @generated from field: int64 file_count = 14;
   */
  fileCount: bigint;

  /**
   * @generated from field: int64 total_rows = 15;
   */
  totalRows: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 16;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 17;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string materialization_key_json = 19;
   */
  materializationKeyJson: string;

  /**
   * @generated from field: string output_schema_bytes_base64 = 20;
   */
  outputSchemaBytesBase64: string;

  /**
   * @generated from field: string source_meta_json = 21;
   */
  sourceMetaJson: string;
};

/**
 * Describes the message chalk.server.v1.MaterializedAggregateTileMeta.
 * Use `create(MaterializedAggregateTileMetaSchema)` to create a new message.
 */
export const MaterializedAggregateTileMetaSchema: GenMessage<MaterializedAggregateTileMeta> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 32);

/**
 * @generated from message chalk.server.v1.MaterializedAggregateTileFileMeta
 */
export type MaterializedAggregateTileFileMeta = Message<"chalk.server.v1.MaterializedAggregateTileFileMeta"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string environment_id = 7;
   */
  environmentId: string;

  /**
   * @generated from field: string deployment_id = 2;
   */
  deploymentId: string;

  /**
   * @generated from field: int64 file_ordinal = 3;
   */
  fileOrdinal: bigint;

  /**
   * @generated from field: int64 row_count = 4;
   */
  rowCount: bigint;

  /**
   * @generated from field: string uri = 5;
   */
  uri: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message chalk.server.v1.MaterializedAggregateTileFileMeta.
 * Use `create(MaterializedAggregateTileFileMetaSchema)` to create a new message.
 */
export const MaterializedAggregateTileFileMetaSchema: GenMessage<MaterializedAggregateTileFileMeta> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 33);

/**
 * @generated from message chalk.server.v1.ListMaterializedAggregateTilesFilters
 */
export type ListMaterializedAggregateTilesFilters = Message<"chalk.server.v1.ListMaterializedAggregateTilesFilters"> & {
  /**
   * @generated from field: optional string aggregate_backfill_id = 1;
   */
  aggregateBackfillId?: string;
};

/**
 * Describes the message chalk.server.v1.ListMaterializedAggregateTilesFilters.
 * Use `create(ListMaterializedAggregateTilesFiltersSchema)` to create a new message.
 */
export const ListMaterializedAggregateTilesFiltersSchema: GenMessage<ListMaterializedAggregateTilesFilters> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 34);

/**
 * @generated from message chalk.server.v1.ListMaterializedAggregateTilesRequest
 */
export type ListMaterializedAggregateTilesRequest = Message<"chalk.server.v1.ListMaterializedAggregateTilesRequest"> & {
  /**
   * @generated from field: optional string cursor = 1;
   */
  cursor?: string;

  /**
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;

  /**
   * @generated from field: optional chalk.server.v1.ListMaterializedAggregateTilesFilters filters = 3;
   */
  filters?: ListMaterializedAggregateTilesFilters;
};

/**
 * Describes the message chalk.server.v1.ListMaterializedAggregateTilesRequest.
 * Use `create(ListMaterializedAggregateTilesRequestSchema)` to create a new message.
 */
export const ListMaterializedAggregateTilesRequestSchema: GenMessage<ListMaterializedAggregateTilesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 35);

/**
 * @generated from message chalk.server.v1.ListMaterializedAggregateTilesResponse
 */
export type ListMaterializedAggregateTilesResponse = Message<"chalk.server.v1.ListMaterializedAggregateTilesResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.MaterializedAggregateTileMeta tiles = 1;
   */
  tiles: MaterializedAggregateTileMeta[];

  /**
   * @generated from field: optional string next_cursor = 2;
   */
  nextCursor?: string;
};

/**
 * Describes the message chalk.server.v1.ListMaterializedAggregateTilesResponse.
 * Use `create(ListMaterializedAggregateTilesResponseSchema)` to create a new message.
 */
export const ListMaterializedAggregateTilesResponseSchema: GenMessage<ListMaterializedAggregateTilesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 36);

/**
 * @generated from message chalk.server.v1.ListMaterializedAggregateTilesForTimelineRequest
 */
export type ListMaterializedAggregateTilesForTimelineRequest = Message<"chalk.server.v1.ListMaterializedAggregateTilesForTimelineRequest"> & {
  /**
   * @generated from field: string materialization_key_hash = 1;
   */
  materializationKeyHash: string;

  /**
   * If set, only tiles that overlap [lower_bound, upper_bound) are returned.
   *
   * @generated from field: optional chalk.server.v1.MaterializedAggregateTileTimelineInterval time_window = 2;
   */
  timeWindow?: MaterializedAggregateTileTimelineInterval;

  /**
   * Opaque token: the coverage_lower_bound of the last tile already returned.
   * Independent of time_window; when both are set they compose.
   *
   * @generated from field: optional string cursor = 3;
   */
  cursor?: string;

  /**
   * @generated from field: optional int32 limit = 4;
   */
  limit?: number;
};

/**
 * Describes the message chalk.server.v1.ListMaterializedAggregateTilesForTimelineRequest.
 * Use `create(ListMaterializedAggregateTilesForTimelineRequestSchema)` to create a new message.
 */
export const ListMaterializedAggregateTilesForTimelineRequestSchema: GenMessage<ListMaterializedAggregateTilesForTimelineRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 37);

/**
 * @generated from message chalk.server.v1.ListMaterializedAggregateTilesForTimelineResponse
 */
export type ListMaterializedAggregateTilesForTimelineResponse = Message<"chalk.server.v1.ListMaterializedAggregateTilesForTimelineResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.MaterializedAggregateTileMeta tiles = 1;
   */
  tiles: MaterializedAggregateTileMeta[];

  /**
   * @generated from field: optional string next_cursor = 2;
   */
  nextCursor?: string;

  /**
   * Data rows across every tile in the time window, not just this page; set on the first page only.
   *
   * @generated from field: optional int64 total_rows = 3;
   */
  totalRows?: bigint;
};

/**
 * Describes the message chalk.server.v1.ListMaterializedAggregateTilesForTimelineResponse.
 * Use `create(ListMaterializedAggregateTilesForTimelineResponseSchema)` to create a new message.
 */
export const ListMaterializedAggregateTilesForTimelineResponseSchema: GenMessage<ListMaterializedAggregateTilesForTimelineResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 38);

/**
 * @generated from message chalk.server.v1.ListMaterializedAggregateTileFilesRequest
 */
export type ListMaterializedAggregateTileFilesRequest = Message<"chalk.server.v1.ListMaterializedAggregateTileFilesRequest"> & {
  /**
   * @generated from field: int64 manifest_id = 1;
   */
  manifestId: bigint;

  /**
   * @generated from field: optional string cursor = 2;
   */
  cursor?: string;

  /**
   * @generated from field: optional int32 limit = 3;
   */
  limit?: number;
};

/**
 * Describes the message chalk.server.v1.ListMaterializedAggregateTileFilesRequest.
 * Use `create(ListMaterializedAggregateTileFilesRequestSchema)` to create a new message.
 */
export const ListMaterializedAggregateTileFilesRequestSchema: GenMessage<ListMaterializedAggregateTileFilesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 39);

/**
 * @generated from message chalk.server.v1.ListMaterializedAggregateTileFilesResponse
 */
export type ListMaterializedAggregateTileFilesResponse = Message<"chalk.server.v1.ListMaterializedAggregateTileFilesResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.MaterializedAggregateTileFileMeta files = 1;
   */
  files: MaterializedAggregateTileFileMeta[];

  /**
   * @generated from field: optional string next_cursor = 2;
   */
  nextCursor?: string;
};

/**
 * Describes the message chalk.server.v1.ListMaterializedAggregateTileFilesResponse.
 * Use `create(ListMaterializedAggregateTileFilesResponseSchema)` to create a new message.
 */
export const ListMaterializedAggregateTileFilesResponseSchema: GenMessage<ListMaterializedAggregateTileFilesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 40);

/**
 * One tile file, paired with a short-lived signed URL that downloads its raw
 * parquet bytes. signed_url is empty when signing failed; `error` then says why,
 * so one unreachable file does not fail the whole manifest.
 *
 * @generated from message chalk.server.v1.MaterializedAggregateTileFileDownloadLink
 */
export type MaterializedAggregateTileFileDownloadLink = Message<"chalk.server.v1.MaterializedAggregateTileFileDownloadLink"> & {
  /**
   * @generated from field: int64 file_id = 1;
   */
  fileId: bigint;

  /**
   * @generated from field: int64 file_ordinal = 2;
   */
  fileOrdinal: bigint;

  /**
   * @generated from field: string uri = 3;
   */
  uri: string;

  /**
   * @generated from field: int64 row_count = 4;
   */
  rowCount: bigint;

  /**
   * @generated from field: string signed_url = 5;
   */
  signedUrl: string;

  /**
   * @generated from field: string error = 6;
   */
  error: string;
};

/**
 * Describes the message chalk.server.v1.MaterializedAggregateTileFileDownloadLink.
 * Use `create(MaterializedAggregateTileFileDownloadLinkSchema)` to create a new message.
 */
export const MaterializedAggregateTileFileDownloadLinkSchema: GenMessage<MaterializedAggregateTileFileDownloadLink> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 41);

/**
 * @generated from message chalk.server.v1.GetMaterializedAggregateTileDownloadLinksRequest
 */
export type GetMaterializedAggregateTileDownloadLinksRequest = Message<"chalk.server.v1.GetMaterializedAggregateTileDownloadLinksRequest"> & {
  /**
   * @generated from field: int64 manifest_id = 1;
   */
  manifestId: bigint;

  /**
   * File ids to sign, as returned by ListMaterializedAggregateTileFiles. Empty
   * signs every file on the manifest, up to the server's per-call cap.
   *
   * @generated from field: repeated int64 file_ids = 2;
   */
  fileIds: bigint[];
};

/**
 * Describes the message chalk.server.v1.GetMaterializedAggregateTileDownloadLinksRequest.
 * Use `create(GetMaterializedAggregateTileDownloadLinksRequestSchema)` to create a new message.
 */
export const GetMaterializedAggregateTileDownloadLinksRequestSchema: GenMessage<GetMaterializedAggregateTileDownloadLinksRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 42);

/**
 * @generated from message chalk.server.v1.GetMaterializedAggregateTileDownloadLinksResponse
 */
export type GetMaterializedAggregateTileDownloadLinksResponse = Message<"chalk.server.v1.GetMaterializedAggregateTileDownloadLinksResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.MaterializedAggregateTileFileDownloadLink links = 1;
   */
  links: MaterializedAggregateTileFileDownloadLink[];

  /**
   * Shared expiry of every signed_url above.
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 2;
   */
  expiresAt?: Timestamp;
};

/**
 * Describes the message chalk.server.v1.GetMaterializedAggregateTileDownloadLinksResponse.
 * Use `create(GetMaterializedAggregateTileDownloadLinksResponseSchema)` to create a new message.
 */
export const GetMaterializedAggregateTileDownloadLinksResponseSchema: GenMessage<GetMaterializedAggregateTileDownloadLinksResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 43);

/**
 * @generated from message chalk.server.v1.GetMaterializedAggregateTileRowCountChartRequest
 */
export type GetMaterializedAggregateTileRowCountChartRequest = Message<"chalk.server.v1.GetMaterializedAggregateTileRowCountChartRequest"> & {
  /**
   * @generated from field: string materialization_key_hash = 1;
   */
  materializationKeyHash: string;

  /**
   * If set, only tiles that overlap [lower_bound, upper_bound) are included.
   *
   * @generated from field: optional chalk.server.v1.MaterializedAggregateTileTimelineInterval time_window = 2;
   */
  timeWindow?: MaterializedAggregateTileTimelineInterval;
};

/**
 * Describes the message chalk.server.v1.GetMaterializedAggregateTileRowCountChartRequest.
 * Use `create(GetMaterializedAggregateTileRowCountChartRequestSchema)` to create a new message.
 */
export const GetMaterializedAggregateTileRowCountChartRequestSchema: GenMessage<GetMaterializedAggregateTileRowCountChartRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 44);

/**
 * @generated from message chalk.server.v1.GetMaterializedAggregateTileRowCountChartResponse
 */
export type GetMaterializedAggregateTileRowCountChartResponse = Message<"chalk.server.v1.GetMaterializedAggregateTileRowCountChartResponse"> & {
  /**
   * One x point per distinct tile coverage window, valued at the stored row
   * count of that window's newest manifest.
   *
   * @generated from field: chalk.chart.v1.DenseTimeSeriesChart chart = 1;
   */
  chart?: DenseTimeSeriesChart;
};

/**
 * Describes the message chalk.server.v1.GetMaterializedAggregateTileRowCountChartResponse.
 * Use `create(GetMaterializedAggregateTileRowCountChartResponseSchema)` to create a new message.
 */
export const GetMaterializedAggregateTileRowCountChartResponseSchema: GenMessage<GetMaterializedAggregateTileRowCountChartResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 45);

/**
 * Executes a server-defined tile extraction for one primary-key value. Callers
 * choose only the tile, scalar key value, and bounded time range; SQL identifiers
 * and extraction functions are resolved from the stored materialization key.
 *
 * @generated from message chalk.server.v1.GetMaterializedAggregateTileValuesRequest
 */
export type GetMaterializedAggregateTileValuesRequest = Message<"chalk.server.v1.GetMaterializedAggregateTileValuesRequest"> & {
  /**
   * @generated from field: string materialization_key_hash = 1;
   */
  materializationKeyHash: string;

  /**
   * @generated from field: string primary_key_value = 2;
   */
  primaryKeyValue: string;

  /**
   * @generated from field: chalk.server.v1.MaterializedAggregateTileTimelineInterval time_window = 3;
   */
  timeWindow?: MaterializedAggregateTileTimelineInterval;

  /**
   * @generated from field: optional string resource_group = 4;
   */
  resourceGroup?: string;
};

/**
 * Describes the message chalk.server.v1.GetMaterializedAggregateTileValuesRequest.
 * Use `create(GetMaterializedAggregateTileValuesRequestSchema)` to create a new message.
 */
export const GetMaterializedAggregateTileValuesRequestSchema: GenMessage<GetMaterializedAggregateTileValuesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 46);

/**
 * @generated from message chalk.server.v1.GetMaterializedAggregateTileValuesResponse
 */
export type GetMaterializedAggregateTileValuesResponse = Message<"chalk.server.v1.GetMaterializedAggregateTileValuesResponse"> & {
  /**
   * @generated from field: chalk.protosql.v1.ExecuteSqlQueryResponse response = 1;
   */
  response?: ExecuteSqlQueryResponse;
};

/**
 * Describes the message chalk.server.v1.GetMaterializedAggregateTileValuesResponse.
 * Use `create(GetMaterializedAggregateTileValuesResponseSchema)` to create a new message.
 */
export const GetMaterializedAggregateTileValuesResponseSchema: GenMessage<GetMaterializedAggregateTileValuesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 47);

/**
 * @generated from message chalk.server.v1.DeleteMaterializedAggregateTileRequest
 */
export type DeleteMaterializedAggregateTileRequest = Message<"chalk.server.v1.DeleteMaterializedAggregateTileRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;
};

/**
 * Describes the message chalk.server.v1.DeleteMaterializedAggregateTileRequest.
 * Use `create(DeleteMaterializedAggregateTileRequestSchema)` to create a new message.
 */
export const DeleteMaterializedAggregateTileRequestSchema: GenMessage<DeleteMaterializedAggregateTileRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 48);

/**
 * @generated from message chalk.server.v1.DeleteMaterializedAggregateTileResponse
 */
export type DeleteMaterializedAggregateTileResponse = Message<"chalk.server.v1.DeleteMaterializedAggregateTileResponse"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;
};

/**
 * Describes the message chalk.server.v1.DeleteMaterializedAggregateTileResponse.
 * Use `create(DeleteMaterializedAggregateTileResponseSchema)` to create a new message.
 */
export const DeleteMaterializedAggregateTileResponseSchema: GenMessage<DeleteMaterializedAggregateTileResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 49);

/**
 * @generated from message chalk.server.v1.GetDatasetRevisionPreviewRequest
 */
export type GetDatasetRevisionPreviewRequest = Message<"chalk.server.v1.GetDatasetRevisionPreviewRequest"> & {
  /**
   * @generated from field: string revision_id = 1;
   */
  revisionId: string;

  /**
   * Return only stored, asynchronously computed profiles and their status. Skips
   * output rows and legacy engine summaries; profiles may be empty until ready.
   *
   * @generated from field: bool profiles_only = 2;
   */
  profilesOnly: boolean;
};

/**
 * Describes the message chalk.server.v1.GetDatasetRevisionPreviewRequest.
 * Use `create(GetDatasetRevisionPreviewRequestSchema)` to create a new message.
 */
export const GetDatasetRevisionPreviewRequestSchema: GenMessage<GetDatasetRevisionPreviewRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 50);

/**
 * @generated from message chalk.server.v1.GetDatasetRevisionPreviewResponse
 */
export type GetDatasetRevisionPreviewResponse = Message<"chalk.server.v1.GetDatasetRevisionPreviewResponse"> & {
  /**
   * @generated from field: google.protobuf.Value output_preview = 1;
   */
  outputPreview?: Value;

  /**
   * @generated from field: google.protobuf.Value summary = 2;
   */
  summary?: Value;

  /**
   * Whole-revision profiles computed asynchronously after upload. Empty while
   * profiling is pending or for legacy revisions without a stored schema.
   *
   * @generated from field: repeated chalk.common.v1.ColumnProfile column_profiles = 3;
   */
  columnProfiles: ColumnProfile[];

  /**
   * @generated from field: chalk.server.v1.DatasetProfileStatus profile_status = 4;
   */
  profileStatus: DatasetProfileStatus;
};

/**
 * Describes the message chalk.server.v1.GetDatasetRevisionPreviewResponse.
 * Use `create(GetDatasetRevisionPreviewResponseSchema)` to create a new message.
 */
export const GetDatasetRevisionPreviewResponseSchema: GenMessage<GetDatasetRevisionPreviewResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 51);

/**
 * @generated from message chalk.server.v1.GenerateDatasetStatsRequest
 */
export type GenerateDatasetStatsRequest = Message<"chalk.server.v1.GenerateDatasetStatsRequest"> & {
  /**
   * @generated from field: string revision_id = 1;
   */
  revisionId: string;
};

/**
 * Describes the message chalk.server.v1.GenerateDatasetStatsRequest.
 * Use `create(GenerateDatasetStatsRequestSchema)` to create a new message.
 */
export const GenerateDatasetStatsRequestSchema: GenMessage<GenerateDatasetStatsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 52);

/**
 * @generated from message chalk.server.v1.GenerateDatasetStatsResponse
 */
export type GenerateDatasetStatsResponse = Message<"chalk.server.v1.GenerateDatasetStatsResponse"> & {
  /**
   * Deprecated synchronous result. Read the profiles and job status from
   * GetDatasetRevisionPreview after this RPC queues the job.
   *
   * @generated from field: google.protobuf.Value summary = 1;
   */
  summary?: Value;
};

/**
 * Describes the message chalk.server.v1.GenerateDatasetStatsResponse.
 * Use `create(GenerateDatasetStatsResponseSchema)` to create a new message.
 */
export const GenerateDatasetStatsResponseSchema: GenMessage<GenerateDatasetStatsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 53);

/**
 * @generated from message chalk.server.v1.DatasetEdf
 */
export type DatasetEdf = Message<"chalk.server.v1.DatasetEdf"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string job_id = 2;
   */
  jobId: string;

  /**
   * @generated from field: string feature_name = 3;
   */
  featureName: string;

  /**
   * @generated from field: double data_max = 4;
   */
  dataMax: number;

  /**
   * @generated from field: double data_min = 5;
   */
  dataMin: number;

  /**
   * @generated from field: int64 data_count = 6;
   */
  dataCount: bigint;

  /**
   * @generated from field: int32 bucket_count = 7;
   */
  bucketCount: number;

  /**
   * @generated from field: repeated double bucket_values = 8;
   */
  bucketValues: number[];
};

/**
 * Describes the message chalk.server.v1.DatasetEdf.
 * Use `create(DatasetEdfSchema)` to create a new message.
 */
export const DatasetEdfSchema: GenMessage<DatasetEdf> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 54);

/**
 * @generated from message chalk.server.v1.GetDatasetEdfsRequest
 */
export type GetDatasetEdfsRequest = Message<"chalk.server.v1.GetDatasetEdfsRequest"> & {
  /**
   * @generated from field: string revision_id = 1;
   */
  revisionId: string;
};

/**
 * Describes the message chalk.server.v1.GetDatasetEdfsRequest.
 * Use `create(GetDatasetEdfsRequestSchema)` to create a new message.
 */
export const GetDatasetEdfsRequestSchema: GenMessage<GetDatasetEdfsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 55);

/**
 * @generated from message chalk.server.v1.GetDatasetEdfsResponse
 */
export type GetDatasetEdfsResponse = Message<"chalk.server.v1.GetDatasetEdfsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.DatasetEdf edfs = 1;
   */
  edfs: DatasetEdf[];
};

/**
 * Describes the message chalk.server.v1.GetDatasetEdfsResponse.
 * Use `create(GetDatasetEdfsResponseSchema)` to create a new message.
 */
export const GetDatasetEdfsResponseSchema: GenMessage<GetDatasetEdfsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 56);

/**
 * @generated from message chalk.server.v1.GenerateDatasetEdfsRequest
 */
export type GenerateDatasetEdfsRequest = Message<"chalk.server.v1.GenerateDatasetEdfsRequest"> & {
  /**
   * @generated from field: string revision_id = 1;
   */
  revisionId: string;
};

/**
 * Describes the message chalk.server.v1.GenerateDatasetEdfsRequest.
 * Use `create(GenerateDatasetEdfsRequestSchema)` to create a new message.
 */
export const GenerateDatasetEdfsRequestSchema: GenMessage<GenerateDatasetEdfsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 57);

/**
 * @generated from message chalk.server.v1.GenerateDatasetEdfsResponse
 */
export type GenerateDatasetEdfsResponse = Message<"chalk.server.v1.GenerateDatasetEdfsResponse"> & {
  /**
   * @generated from field: repeated string features = 1;
   */
  features: string[];
};

/**
 * Describes the message chalk.server.v1.GenerateDatasetEdfsResponse.
 * Use `create(GenerateDatasetEdfsResponseSchema)` to create a new message.
 */
export const GenerateDatasetEdfsResponseSchema: GenMessage<GenerateDatasetEdfsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_datasets, 58);

/**
 * @generated from enum chalk.server.v1.DatasetRevisionStatus
 */
export enum DatasetRevisionStatus {
  /**
   * @generated from enum value: DATASET_REVISION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DATASET_REVISION_STATUS_UNKNOWN = 1;
   */
  UNKNOWN = 1,

  /**
   * @generated from enum value: DATASET_REVISION_STATUS_WORKING = 2;
   */
  WORKING = 2,

  /**
   * @generated from enum value: DATASET_REVISION_STATUS_COMPLETED = 3;
   */
  COMPLETED = 3,

  /**
   * @generated from enum value: DATASET_REVISION_STATUS_FAILED = 4;
   */
  FAILED = 4,

  /**
   * @generated from enum value: DATASET_REVISION_STATUS_CANCELED = 5;
   */
  CANCELED = 5,

  /**
   * @generated from enum value: DATASET_REVISION_STATUS_QUEUED = 6;
   */
  QUEUED = 6,
}

/**
 * Describes the enum chalk.server.v1.DatasetRevisionStatus.
 */
export const DatasetRevisionStatusSchema: GenEnum<DatasetRevisionStatus> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_datasets, 0);

/**
 * @generated from enum chalk.server.v1.DatasetVersion
 */
export enum DatasetVersion {
  /**
   * @generated from enum value: DATASET_VERSION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DATASET_VERSION_UNKNOWN = 1;
   */
  UNKNOWN = 1,

  /**
   * @generated from enum value: DATASET_VERSION_BIGQUERY_JOB_WITH_B32_ENCODED_COLNAMES = 2;
   */
  BIGQUERY_JOB_WITH_B32_ENCODED_COLNAMES = 2,

  /**
   * @generated from enum value: DATASET_VERSION_DATASET_WRITER = 3;
   */
  DATASET_WRITER = 3,

  /**
   * @generated from enum value: DATASET_VERSION_BIGQUERY_JOB_WITH_B32_ENCODED_COLNAMES_V2 = 4;
   */
  BIGQUERY_JOB_WITH_B32_ENCODED_COLNAMES_V2 = 4,

  /**
   * @generated from enum value: DATASET_VERSION_COMPUTE_RESOLVER_OUTPUT_V1 = 5;
   */
  COMPUTE_RESOLVER_OUTPUT_V1 = 5,

  /**
   * @generated from enum value: DATASET_VERSION_NATIVE_DTYPES = 6;
   */
  NATIVE_DTYPES = 6,

  /**
   * @generated from enum value: DATASET_VERSION_NATIVE_COLUMN_NAMES = 7;
   */
  NATIVE_COLUMN_NAMES = 7,
}

/**
 * Describes the enum chalk.server.v1.DatasetVersion.
 */
export const DatasetVersionSchema: GenEnum<DatasetVersion> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_datasets, 1);

/**
 * @generated from enum chalk.server.v1.OfflineQueryGivensVersion
 */
export enum OfflineQueryGivensVersion {
  /**
   * @generated from enum value: OFFLINE_QUERY_GIVENS_VERSION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: OFFLINE_QUERY_GIVENS_VERSION_UNKNOWN = 1;
   */
  UNKNOWN = 1,

  /**
   * @generated from enum value: OFFLINE_QUERY_GIVENS_VERSION_NATIVE_TS_FEATURE_FOR_ROOT_NS = 2;
   */
  NATIVE_TS_FEATURE_FOR_ROOT_NS = 2,

  /**
   * @generated from enum value: OFFLINE_QUERY_GIVENS_VERSION_SINGLE_TS_COL_NAME = 3;
   */
  SINGLE_TS_COL_NAME = 3,

  /**
   * @generated from enum value: OFFLINE_QUERY_GIVENS_VERSION_SINGLE_TS_COL_NAME_WITH_URI_PREFIX = 4;
   */
  SINGLE_TS_COL_NAME_WITH_URI_PREFIX = 4,
}

/**
 * Describes the enum chalk.server.v1.OfflineQueryGivensVersion.
 */
export const OfflineQueryGivensVersionSchema: GenEnum<OfflineQueryGivensVersion> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_datasets, 2);

/**
 * @generated from enum chalk.server.v1.DatasetSortColumn
 */
export enum DatasetSortColumn {
  /**
   * @generated from enum value: DATASET_SORT_COLUMN_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DATASET_SORT_COLUMN_CREATED_AT = 1;
   */
  CREATED_AT = 1,

  /**
   * @generated from enum value: DATASET_SORT_COLUMN_UPDATED_AT = 2;
   */
  UPDATED_AT = 2,
}

/**
 * Describes the enum chalk.server.v1.DatasetSortColumn.
 */
export const DatasetSortColumnSchema: GenEnum<DatasetSortColumn> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_datasets, 3);

/**
 * @generated from enum chalk.server.v1.SortOrder
 */
export enum SortOrder {
  /**
   * @generated from enum value: SORT_ORDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SORT_ORDER_DESC = 1;
   */
  DESC = 1,

  /**
   * @generated from enum value: SORT_ORDER_ASC = 2;
   */
  ASC = 2,
}

/**
 * Describes the enum chalk.server.v1.SortOrder.
 */
export const SortOrderSchema: GenEnum<SortOrder> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_datasets, 4);

/**
 * Whether a dataset is named or anonymous (anonymous = no dataset_name).
 *
 * @generated from enum chalk.server.v1.DatasetKind
 */
export enum DatasetKind {
  /**
   * @generated from enum value: DATASET_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DATASET_KIND_NAMED = 1;
   */
  NAMED = 1,

  /**
   * @generated from enum value: DATASET_KIND_ANONYMOUS = 2;
   */
  ANONYMOUS = 2,
}

/**
 * Describes the enum chalk.server.v1.DatasetKind.
 */
export const DatasetKindSchema: GenEnum<DatasetKind> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_datasets, 5);

/**
 * Availability of one shard's performance summary. Distinguishes a summary that
 * exists (fetch its url) from one that is still being produced vs one the shard
 * finished without producing — so the UI never conflates missing with failed.
 * "Failed to fetch" is not modeled here: a signed url only fails at the browser.
 *
 * @generated from enum chalk.server.v1.ShardPerformanceSummaryStatus
 */
export enum ShardPerformanceSummaryStatus {
  /**
   * @generated from enum value: SHARD_PERFORMANCE_SUMMARY_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SHARD_PERFORMANCE_SUMMARY_STATUS_AVAILABLE = 1;
   */
  AVAILABLE = 1,

  /**
   * @generated from enum value: SHARD_PERFORMANCE_SUMMARY_STATUS_PENDING = 2;
   */
  PENDING = 2,

  /**
   * @generated from enum value: SHARD_PERFORMANCE_SUMMARY_STATUS_NONE = 3;
   */
  NONE = 3,
}

/**
 * Describes the enum chalk.server.v1.ShardPerformanceSummaryStatus.
 */
export const ShardPerformanceSummaryStatusSchema: GenEnum<ShardPerformanceSummaryStatus> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_datasets, 6);

/**
 * @generated from enum chalk.server.v1.DatasetProfileStatus
 */
export enum DatasetProfileStatus {
  /**
   * @generated from enum value: DATASET_PROFILE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DATASET_PROFILE_STATUS_QUEUED = 1;
   */
  QUEUED = 1,

  /**
   * @generated from enum value: DATASET_PROFILE_STATUS_RUNNING = 2;
   */
  RUNNING = 2,

  /**
   * @generated from enum value: DATASET_PROFILE_STATUS_COMPLETED = 3;
   */
  COMPLETED = 3,

  /**
   * @generated from enum value: DATASET_PROFILE_STATUS_FAILED = 4;
   */
  FAILED = 4,
}

/**
 * Describes the enum chalk.server.v1.DatasetProfileStatus.
 */
export const DatasetProfileStatusSchema: GenEnum<DatasetProfileStatus> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_datasets, 7);

/**
 * @generated from service chalk.server.v1.DatasetMetadataService
 */
export const DatasetMetadataService: GenService<{
  /**
   * @generated from rpc chalk.server.v1.DatasetMetadataService.ListDatasets
   */
  listDatasets: {
    methodKind: "unary";
    input: typeof ListDatasetsRequestSchema;
    output: typeof ListDatasetsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DatasetMetadataService.GetDataset
   */
  getDataset: {
    methodKind: "unary";
    input: typeof GetDatasetRequestSchema;
    output: typeof GetDatasetResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DatasetMetadataService.ListDatasetRevisions
   */
  listDatasetRevisions: {
    methodKind: "unary";
    input: typeof ListDatasetRevisionsRequestSchema;
    output: typeof ListDatasetRevisionsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DatasetMetadataService.GetDatasetRevision
   */
  getDatasetRevision: {
    methodKind: "unary";
    input: typeof GetDatasetRevisionRequestSchema;
    output: typeof GetDatasetRevisionResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DatasetMetadataService.GetDatasetRevisionDownloadLinks
   */
  getDatasetRevisionDownloadLinks: {
    methodKind: "unary";
    input: typeof GetDatasetRevisionDownloadLinksRequestSchema;
    output: typeof GetDatasetRevisionDownloadLinksResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DatasetMetadataService.GetDatasetRevisionPerformanceLinks
   */
  getDatasetRevisionPerformanceLinks: {
    methodKind: "unary";
    input: typeof GetDatasetRevisionPerformanceLinksRequestSchema;
    output: typeof GetDatasetRevisionPerformanceLinksResponseSchema;
  },
  /**
   * Server-streaming variant of GetDatasetRevisionDownloadLinks. Each emitted
   * message carries a chunk of download links for the given revision; clients
   * must concatenate the repeated fields across messages to obtain the full
   * set. Messages that contain signed URLs also carry the shared expiration
   * timestamp. Use this RPC when a single response would exceed gRPC
   * message-size limits or when callers want to begin downloading before all
   * URLs have been signed.
   *
   * @generated from rpc chalk.server.v1.DatasetMetadataService.StreamDatasetRevisionDownloadLinks
   */
  streamDatasetRevisionDownloadLinks: {
    methodKind: "server_streaming";
    input: typeof StreamDatasetRevisionDownloadLinksRequestSchema;
    output: typeof StreamDatasetRevisionDownloadLinksResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DatasetMetadataService.RenameDataset
   */
  renameDataset: {
    methodKind: "unary";
    input: typeof RenameDatasetRequestSchema;
    output: typeof RenameDatasetResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DatasetMetadataService.ArchiveDatasetRevision
   * @deprecated
   */
  archiveDatasetRevision: {
    methodKind: "unary";
    input: typeof ArchiveDatasetRevisionRequestSchema;
    output: typeof ArchiveDatasetRevisionResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DatasetMetadataService.ArchiveDatasetRevisions
   */
  archiveDatasetRevisions: {
    methodKind: "unary";
    input: typeof ArchiveDatasetRevisionsRequestSchema;
    output: typeof ArchiveDatasetRevisionsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DatasetMetadataService.DeleteDataset
   */
  deleteDataset: {
    methodKind: "unary";
    input: typeof DeleteDatasetRequestSchema;
    output: typeof DeleteDatasetResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DatasetMetadataService.ListMaterializedAggregateTiles
   * @deprecated
   */
  listMaterializedAggregateTiles: {
    methodKind: "unary";
    input: typeof ListMaterializedAggregateTilesRequestSchema;
    output: typeof ListMaterializedAggregateTilesResponseSchema;
  },
  /**
   * Timeline skeletons for the TilesTimeline view; manifests are fetched
   * separately via ListMaterializedAggregateTilesForTimeline.
   *
   * @generated from rpc chalk.server.v1.DatasetMetadataService.ListMaterializedAggregateTileTimelines
   */
  listMaterializedAggregateTileTimelines: {
    methodKind: "unary";
    input: typeof ListMaterializedAggregateTileTimelinesRequestSchema;
    output: typeof ListMaterializedAggregateTileTimelinesResponseSchema;
  },
  /**
   * The TilesTimeline filter vocabulary, so the client keeps no parallel copy of it.
   *
   * @generated from rpc chalk.server.v1.DatasetMetadataService.GetMaterializedAggregateTileFacets
   */
  getMaterializedAggregateTileFacets: {
    methodKind: "unary";
    input: typeof GetMaterializedAggregateTileFacetsRequestSchema;
    output: typeof GetMaterializedAggregateTileFacetsResponseSchema;
  },
  /**
   * Facet values and counts for the TilesTimeline filter menu.
   *
   * @generated from rpc chalk.server.v1.DatasetMetadataService.GetMaterializedAggregateTileFacetValues
   */
  getMaterializedAggregateTileFacetValues: {
    methodKind: "unary";
    input: typeof GetMaterializedAggregateTileFacetValuesRequestSchema;
    output: typeof GetMaterializedAggregateTileFacetValuesResponseSchema;
  },
  /**
   * The active deployment's materialized aggregations that compute or read one feature.
   *
   * @generated from rpc chalk.server.v1.DatasetMetadataService.GetFeatureMaterializedAggregations
   */
  getFeatureMaterializedAggregations: {
    methodKind: "unary";
    input: typeof GetFeatureMaterializedAggregationsRequestSchema;
    output: typeof GetFeatureMaterializedAggregationsResponseSchema;
  },
  /**
   * Gaps per windowed feature with offline tiles, paged by fqn; features with no tiles are omitted.
   *
   * @generated from rpc chalk.server.v1.DatasetMetadataService.ListTileFeatureCoverage
   */
  listTileFeatureCoverage: {
    methodKind: "unary";
    input: typeof ListTileFeatureCoverageRequestSchema;
    output: typeof ListTileFeatureCoverageResponseSchema;
  },
  /**
   * Full tile manifests for one timeline (one materialization_key_hash).
   *
   * @generated from rpc chalk.server.v1.DatasetMetadataService.ListMaterializedAggregateTilesForTimeline
   */
  listMaterializedAggregateTilesForTimeline: {
    methodKind: "unary";
    input: typeof ListMaterializedAggregateTilesForTimelineRequestSchema;
    output: typeof ListMaterializedAggregateTilesForTimelineResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DatasetMetadataService.ListMaterializedAggregateTileFiles
   */
  listMaterializedAggregateTileFiles: {
    methodKind: "unary";
    input: typeof ListMaterializedAggregateTileFilesRequestSchema;
    output: typeof ListMaterializedAggregateTileFilesResponseSchema;
  },
  /**
   * Row-count-per-tile histogram for one timeline (one
   * materialization_key_hash). Each x point is a tile's coverage_lower_bound;
   * the value is the total stored row count of the newest manifest covering
   * that window, i.e. the number of distinct (primary key, group, bucket)
   * rows materialized for the window.
   *
   * @generated from rpc chalk.server.v1.DatasetMetadataService.GetMaterializedAggregateTileRowCountChart
   */
  getMaterializedAggregateTileRowCountChart: {
    methodKind: "unary";
    input: typeof GetMaterializedAggregateTileRowCountChartRequestSchema;
    output: typeof GetMaterializedAggregateTileRowCountChartResponseSchema;
  },
  /**
   * Returns one extracted aggregate value per bucket for a primary key over a
   * bounded range. This endpoint intentionally does not accept arbitrary SQL.
   *
   * @generated from rpc chalk.server.v1.DatasetMetadataService.GetMaterializedAggregateTileValues
   */
  getMaterializedAggregateTileValues: {
    methodKind: "unary";
    input: typeof GetMaterializedAggregateTileValuesRequestSchema;
    output: typeof GetMaterializedAggregateTileValuesResponseSchema;
  },
  /**
   * Signed download URLs for the raw parquet files a tile manifest points at.
   * The URIs are read from the manifest's own file rows, scoped to the caller's
   * environment, so a caller cannot ask the server to sign an arbitrary object.
   *
   * @generated from rpc chalk.server.v1.DatasetMetadataService.GetMaterializedAggregateTileDownloadLinks
   */
  getMaterializedAggregateTileDownloadLinks: {
    methodKind: "unary";
    input: typeof GetMaterializedAggregateTileDownloadLinksRequestSchema;
    output: typeof GetMaterializedAggregateTileDownloadLinksResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DatasetMetadataService.DeleteMaterializedAggregateTile
   */
  deleteMaterializedAggregateTile: {
    methodKind: "unary";
    input: typeof DeleteMaterializedAggregateTileRequestSchema;
    output: typeof DeleteMaterializedAggregateTileResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DatasetMetadataService.GetDatasetRevisionPreview
   */
  getDatasetRevisionPreview: {
    methodKind: "unary";
    input: typeof GetDatasetRevisionPreviewRequestSchema;
    output: typeof GetDatasetRevisionPreviewResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DatasetMetadataService.GenerateDatasetStats
   */
  generateDatasetStats: {
    methodKind: "unary";
    input: typeof GenerateDatasetStatsRequestSchema;
    output: typeof GenerateDatasetStatsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DatasetMetadataService.GetDatasetEdfs
   */
  getDatasetEdfs: {
    methodKind: "unary";
    input: typeof GetDatasetEdfsRequestSchema;
    output: typeof GetDatasetEdfsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DatasetMetadataService.GenerateDatasetEdfs
   */
  generateDatasetEdfs: {
    methodKind: "unary";
    input: typeof GenerateDatasetEdfsRequestSchema;
    output: typeof GenerateDatasetEdfsResponseSchema;
  },
  /**
   * Mint a signed upload URI for a client-side file. Call once per file; the
   * first call leaves upload_session_id unset and the server returns one.
   * Subsequent calls should pass the same upload_session_id so the server can
   * group all objects together under one finalize.
   *
   * @generated from rpc chalk.server.v1.DatasetMetadataService.GetDatasetUploadUris
   */
  getDatasetUploadUris: {
    methodKind: "unary";
    input: typeof GetDatasetUploadUrisRequestSchema;
    output: typeof GetDatasetUploadUrisResponseSchema;
  },
  /**
   * Finalize an upload session. The server records a new dataset revision
   * pointing at all objects uploaded under upload_session_id and exposes the
   * dataset for queries. Each upload_session_id may be finalized at most once;
   * see FinalizeDatasetUploadRequest for the conflict contract. Not marked
   * IDEMPOTENT because automatic retries could race against finalize completion
   * and surface confusing ALREADY_EXISTS errors to callers.
   *
   * @generated from rpc chalk.server.v1.DatasetMetadataService.FinalizeDatasetUpload
   */
  finalizeDatasetUpload: {
    methodKind: "unary";
    input: typeof FinalizeDatasetUploadRequestSchema;
    output: typeof FinalizeDatasetUploadResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_server_v1_datasets, 0);

